import Axios from "../../Config/API";
import { ClassificacaoCobrancaInterface } from "../../../Interfaces/Cobranca/ClassificacaoCobranca/ClassificacaoCobrancaInterface";
import Service from "../../Service";

export async function AtualizarClassificacaoCobrancaService(
    requestBody: ClassificacaoCobrancaInterface
) {
    return Service(
        Axios.put(
            `/cobranca/classificacaocobranca/atualizarclassificacaocobranca`,
            requestBody
        )
    );
}

export async function ListarClassificacaoCobrancaService() {
    return Service(
        Axios.get<Array<ClassificacaoCobrancaInterface>>(
            `/cobranca/classificacaocobranca/listarclassificacaocobranca`
        )
    );
}

export async function CadastrarClassificacaoCobrancaService(
    requestBody: ClassificacaoCobrancaInterface
) {
    return Service(
        Axios.post(
            `/cobranca/classificacaocobranca/cadastrarclassificacaocobranca`,
            requestBody
        )
    );
}

export async function DeletarClassificacaoCobrancaService(
    idClassificacaoCobranca: number
) {
    return Service(
        Axios.delete(
            `/cobranca/classificacaocobranca/deletarclassificacaocobranca?idClassificacaoCobranca=${idClassificacaoCobranca}`
        )
    );
}

export async function RemoverClassificacaoManualService(ID_CHAVE_ERP: string) {
    return Service(
        Axios.delete(
            `/cobranca/classificacaocobranca/removerclassificacaomanual?ID_CHAVE_ERP=${ID_CHAVE_ERP}`
        )
    );
}

export async function ListarClassificacaoCobrancaGrupoExcecaoService() {
    return Service(
        Axios.get(
            `/cobranca/classificacaocobranca/listarclassificacaocobrancagrupoexcecao`
        )
    );
}

export async function GetClassificacaoCobrancaService(
    ID_CASO_COBRANCA_CLASSIFICACAO_COBRANCA: number
) {
    return Service(
        Axios.get(
            `/cobranca/classificacaocobranca/getclassificacaocobranca?ID_CASO_COBRANCA_CLASSIFICACAO_COBRANCA=${ID_CASO_COBRANCA_CLASSIFICACAO_COBRANCA}`
        )
    );
}
